import { render, staticRenderFns } from "./GlyphSetSavePanel.vue?vue&type=template&id=2f87b777&scoped=true&"
import script from "./GlyphSetSavePanel.vue?vue&type=script&lang=js&"
export * from "./GlyphSetSavePanel.vue?vue&type=script&lang=js&"
import style0 from "./GlyphSetSavePanel.vue?vue&type=style&index=0&id=2f87b777&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87b777",
  null
  
)

export default component.exports